<template>

<div class="input-group">

    <div
      class="CscDateInput"
      @focusout="updateValue"
    >
      <input
        v-if="showDay"
        ref="day"
        v-model="day"
        class="CscDateInput__input CscDateInput__input--day"
        type="number"
        placeholder="TT"
        @input="updateDay"
        @focus="$event.target.select()"
        @blur="day = day.padStart(2, 0)">
      <span
        v-if="showDay && showMonth"
        class="CscDateInput__divider"
      >.</span>
      <input
        v-if="showMonth"
        ref="month"
        v-model="month"
        class="CscDateInput__input CscDateInput__input--month"
        type="number"
        placeholder="MM"
        @input="updateMonth"
        @focus="$event.target.select()"
        @blur="month = month.padStart(2, 0)">
      <span
        v-if="showYear && (showDay || showMonth)"
        class="CscDateInput__divider"
      >.</span>
      <input
        v-if="showYear"
        ref="year"
        v-model="year"
        class="CscDateInput__input CscDateInput__input--year"
        type="number"
        placeholder="JJJJ"
        @focus="$event.target.select()"
        @blur="year = year.padStart(4, 0)">
    </div>
</div>
  </template>
  
  <script>
  import moment from 'moment';
  import { integer } from 'vee-validate/dist/rules';
  export default {
    name: `CscDateInput`,
    props: {
      value: {
        type: [Number, String],
        required: true,
      },
      showDay: {
        type: Boolean,
        default: true,
      },
      showMonth: {
        type: Boolean,
        default: true,
      },
      showYear: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        maxDiff: 100,
        day: `${this.value ? new Date(this.value).getDate() : ``}`,
        month: `${this.value ? new Date(this.value).getMonth() + 1 : ``}`,
        year: `${this.value ? new Date(this.value).getFullYear(): ``}`,
      };
    },
    watch: {
      year(current, prev) {
        if (current > 9999) this.year = prev;
      },
      month(current, prev) {
        this.month = current.replace(/\D/g,'');
        if(current > 12){
            this.month = "00";
        }
      },
      day(current, prev) {
        this.day = current.replace(/\D/g,'');
        if(current > 31){
            this.day = "00";
        }
      },
    },
    methods: {
      updateDay() {
       // this.day = this.day.replace(/\D/g,'');
        //console.log(parseInt(this.day, 10));
        //console.log(parseInt(this.day, 10) < 4);
        //console.log(this.day.length);

        if (!this.day.length || parseInt(this.day, 10) < 4) return;
        if (this.showMonth) this.$refs.month.select();
        else if (this.showYear) this.$refs.year.select();
      },
      updateMonth() {
        if (!this.month.length || parseInt(this.month, 10) < 2) return;
        if (this.showYear) this.$refs.year.select();
      },
      updateValue() {
        const timestamp = Date.parse(`${this.year.padStart(4, 0)}-${this.month}-${this.day}`);
        const md = `${this.year.padStart(4, 0)}-${this.month}-${this.day}` //`${this.day}.${this.month}.${this.year.padStart(4, 0)}`
        if (Number.isNaN(timestamp)) return;
        const ddd = `${this.year.padStart(4, 0)}-${this.month}-${this.day}`
        //console.log("SOURCEDATE ---------->"+ddd);
        //console.log("THEDATEDIFF ---------->"+this.dateDiff(ddd));
        //console.log("maxDiff ---------->"+this.maxDiff);
        if(this.dateDiff(ddd) < this.maxDiff){
            console.log("WE EMIT!!!!!");
            this.$emit(`input`, md);
        }
      },
      dateDiff(d){
        var age_dt, diff_ms, the_age, the_date;
        the_date = new Date(d);
        diff_ms = Date.now() - the_date.getTime();
        age_dt = new Date(diff_ms);
        the_age = Math.abs(age_dt.getUTCFullYear() - 1970);
        return the_age;
      },
    },
  };
  </script>
  
  <style lang="scss">
  .CscDateInput {
    $spacing: 0.75em;
  
    display: inline-flex;
    position: relative;
    overflow: hidden;
    border: 1px solid #888;
    border-radius: 0.25em;

    display: block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  //padding: 0.625rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #8898aa;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  -webkit-box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);
  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);
  -webkit-transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);

    // 1. Hide the spinner button in Chrome, Safari and Firefox.
    &__input {
      padding: $spacing;
      padding-right: $spacing / 2;
      padding-left: $spacing / 2;
      border: none;
      text-align: center;
      /* stylelint-disable-next-line property-no-vendor-prefix */
      -moz-appearance: textfield; // 1
  
      &::-webkit-inner-spin-button {
        display: none; // 1
      }
  
      &:first-child {
        padding-left: $spacing;
      }
  
      &:last-child {
        padding-right: $spacing;
      }
  
      &:focus {
        outline: none;
      }
  
      &--day,
      &--month {
        width: 3em;
      }
  
      &--year {
        width: 4em;
      }
    }
  
    &__divider {
      padding-top: $spacing;
      padding-bottom: $spacing;
      pointer-events: none;
    }
  }
  </style>
  